<template>
  <div class="credit-card-input">
    <div class="form-group">
      <label class="col-sm-4 control-label">Credit Card</label>
      <div class="col-sm-8">
        <button v-if="!field.value" class="btn btn-default" type="button" v-on:click="addCard()">Add Card</button>
        <span class="form-validation-error" v-show="!field.valid && field.dirty">You must add a credit card to complete registration.</span>
        <span class="fa fa-check form-control-feedback-success" v-show="field.value"></span>
        <div class="box-item credit-card" v-if="field.valid">
          <p class="numbers">**** **** **** {{ card.last4 }}</p>
          <p class="name">{{ card.name }}<br/>
          {{ card.address_line1 }}<br/>
          {{ card.address_state }} {{ card.address_country }} {{ card.address_zip }}</p>
          <p class="expiry">{{ card.exp_month }}/{{ card.exp_year }}</p>
          <span v-if="card.brand == 'Visa'" class="fa fa-lg fa-cc-visa"></span>
          <span v-if="card.brand == 'American Express'" class="fa fa-lg fa-cc-amex"></span>
          <span v-if="card.brand == 'MasterCard'" class="fa fa-lg fa-cc-mastercard"></span>
          <span v-if="card.brand == 'Discover'" class="fa fa-lg fa-cc-discover"></span>
          <span v-if="card.brand == 'JCB'" class="fa fa-lg fa-cc-jcb"></span>
          <span v-if="card.brand == 'Diners Club'" class="fa fa-lg fa-cc-diners-club"></span>
          <span v-if="card.brand == 'Unknown'" class="fa fa-lg fa-credit-card-alt"></span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <p class="alert alert-info">Payments are processed by <a href="https://stripe.com/au/">Stripe</a>. You may view their <a href="https://stripe.com/au/privacy/">Privacy Policy here.</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreditCardInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: false,
          valid: false,
          dirty: false
        }
      }
    }
  },
  ready () {
    this.activate()
    this.deactivate()
  },
  route: {
    activate () {
      this.$http.get('public/config', {}).then(({ data }, status, request) => {
        this.stripeHandler = StripeCheckout.configure({
          key: data.stripePublicKey,
          locale: 'auto',
          token: (token) => {
            this.$http.post('public/billing/addCard', { token }).then((response, status, request) => {
              this.listCards()
            })
          }
        })
        this.listCards()
      })
    },
    deactivate () {
      if (this.stripeHandler) {
        this.stripeHandler.close()
        $('iframe.stripe_checkout_app').remove()
      }
    }
  },
  data () {
    return {
      stripeHandler: false,
      cards: [],
      customer: {},
      card: {}
    }
  },
  methods: {
    activate () {
      this.$http.get('public/config', {}).then(({ data }, status, request) => {
        this.stripeHandler = StripeCheckout.configure({
          key: data.stripePublicKey,
          locale: 'auto',
          token: (token) => {
            this.$http.post('public/billing/addCard', { token }).then((response, status, request) => {
              this.listCards()
            })
          }
        })
        this.listCards()
      })
    },
    deactivate () {
      if (this.stripeHandler) {
        this.stripeHandler.close()
        $('iframe.stripe_checkout_app').remove()
      }
    },
    listCards () {
      this.$http.get('public/billing/listCards', {}).then((response, status, request) => {
        this.cards = response.data.result.cards
        this.customer = response.data.result.customer
        if (this.cards.length === 0) {
          this.field.value = false
          this.field.valid = false
        } else {
          this.card = this.cards[0]
          this.field.value = true
          this.field.valid = true
        }
      })
    },
    addCard () {
      this.stripeHandler.open({
        name: this.$parent.companyName,
        description: 'Payment Details',
        currency: 'AUD',
        billingAddress: true,
        panelLabel: 'Save Details',
        allowRememberMe: true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CreditCardInput.vue?0b3b518a